import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/true-size-of-countries/page.tsx");
